<button type="button" class="period-button" [class.open]="open" aria-haspopup="true" [attr.aria-expanded]="open" (click)="toggle()">
    <lucide-icon name="Calendar" [size]="18"></lucide-icon>
    <span>{{ filters.label() }}</span>
    <lucide-icon name="ChevronDown" [size]="16" class="chevron"></lucide-icon>
</button>

@if (open) {
    <div class="period-panel">
        <button type="button" class="period-all" [class.active]="filters.selectedPeriod() === 'all'" (click)="selectAll()">
            {{ 'dashboard.period.all' | transloco }}
        </button>

        <div class="year-row">
            <button type="button" class="year-nav" [disabled]="viewYear <= filters.years[0]" [attr.aria-label]="'common.a11y.previousYear' | transloco" (click)="prevYear()">
                <lucide-icon name="ChevronLeft" [size]="18"></lucide-icon>
            </button>
            <button type="button" class="year-label" [class.active]="isSelectedYear" (click)="selectYear()">
                {{ viewYear }}
            </button>
            <button type="button" class="year-nav" [disabled]="viewYear >= filters.currentYear" [attr.aria-label]="'common.a11y.nextYear' | transloco" (click)="nextYear()">
                <lucide-icon name="ChevronRight" [size]="18"></lucide-icon>
            </button>
        </div>

        <div class="months-grid">
            @for (month of filters.monthLabels(); track $index) {
                <button
                    type="button"
                    class="month"
                    [class.active]="isSelectedMonth($index)"
                    [disabled]="isFuture($index)"
                    (click)="selectMonth($index)"
                >
                    {{ month }}
                </button>
            }
        </div>
    </div>
}
